import moment from "moment";
import { Modal } from "bootstrap";

// https://stackoverflow.com/a/75093937
export const debounce = (func, delay = 600, immediate = false) => {
  let timeout;
  return function () {
    const context = this;
    const args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, delay);
    if (callNow) func.apply(context, args);
  };
};

export const sortAlphabetically = (arr, field) => {
  return arr.sort(function (a, b) {
    if (a && b) {
      let x = field(a).toLowerCase();
      let y = field(b).toLowerCase();

      if (x < y)
        //sort string ascending
        return -1;

      if (x > y) return 1;

      return 0; //default return value (no sorting)
    }
  });
};

export const characterCount = (str, limit) => {
  return limit - str.length + " / " + limit;
};

export const characterCountStyle = (str, limit) => {
  let strLen = str.length;
  let percentage = strLen / limit;

  if (percentage > 1) {
    return "text-danger";
  } else if (percentage < 1 && percentage >= 0.7) {
    return "text-warning";
  }

  return "text-muted";
};

//Used on keyup event
export const removeDoubleSpaces = (str) => {
  return str.replace(/\s+/g, " ");
};

//Used on keyup event
export const removeLeadingSpace = (str) => {
  return str.replace(/^\s+/g, "");
};

export const adjustInputHeight = (e, maxHeight) => {
  if (e.scrollHeight <= maxHeight - 2) {
    return (e.style.height = e.scrollHeight + 2 + "px");
  } else {
    return (e.style.height = maxHeight + "px");
  }
};

// https://stackoverflow.com/a/5723274
export const truncateLongText = (fullStrLen, strLenLimit, separator) => {
  if (fullStrLen.length <= strLenLimit) return fullStrLen;

  separator = separator || "...";

  var sepLen = separator.length,
    charsToShow = strLenLimit - sepLen;
  // frontChars = Math.ceil(charsToShow / 2)
  // backChars = Math.floor(charsToShow / 2);

  return fullStrLen.substr(0, charsToShow) + separator;
};

export const toTitleCase = (str) => {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

//

export function getFormRules() {
  return {
    required: (v) => !!v || "Required",
    email: (v) => /.+@.+/.test(v) || "Invalid Email address",
    uppercase: (v) => /(?=.*[A-Z])/.test(v) || "Must have one uppercase",
    specialChar: (v) =>
      /([!@#$%*])/.test(v) || "Must have one special character [!@#$%*]",
    noSpecialChar: (v) =>
      !/[^a-zA-Z0-9]/.test(v) || "Special characters are not allowed",
    minLength: (v) =>
      (v && v.length >= 12) || "Password must have 12 characters",
    number: (v) => /^\d+$/.test(v) || "Only numeric values are allowed",
    selectRequired: (v) => v.length > 0 || "Required",
    alphaNumeric: (v, msg) => /^[A-Za-z0-9]+$/.test(v) || msg,
    phone: (v) =>
      /^[+]{0,1}\s*[0-9]+\s*(?:\s+[0-9]+\s*)*$/.test(v) ||
      "Invalid Phone Number",
  };
}

export function getCountries() {
  return [
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bhutan",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brazil",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cape Verde",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Colombi",
    "Comoros",
    "Congo (Brazzaville)",
    "Congo",
    "Costa Rica",
    "Cote d'Ivoire",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "East Timor (Timor Timur)",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Ethiopia",
    "Fiji",
    "Finland",
    "France",
    "Gabon",
    "Gambia, The",
    "Georgia",
    "Germany",
    "Ghana",
    "Greece",
    "Grenada",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Korea, North",
    "Korea, South",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macedonia",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Russia",
    "Rwanda",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Vincent",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia and Montenegro",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Swaziland",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Togo",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Zambia",
    "Zimbabwe",
  ];
}

export function removeWhitespaces(str) {
  if (!str) {
    return;
  }

  return str.replace(/\s+/g, "");
}

const srcs = {
  1: "https://flagcdn.com/w40/au.png",
  2: "https://cdn.vuetifyjs.com/images/lists/2.jpg",
  3: "https://cdn.vuetifyjs.com/images/lists/3.jpg",
  4: "https://cdn.vuetifyjs.com/images/lists/4.jpg",
  5: "https://cdn.vuetifyjs.com/images/lists/5.jpg",
};

export function filterCountriesByName(name) {
  const countries = [
    { name: "United States", avatar: srcs[1] },
    { name: "Canada", avatar: srcs[2] },
    { name: "United Kingdom", avatar: srcs[3] },
    { name: "Australia", avatar: srcs[1] },
    { name: "Germany", avatar: srcs[4] },
    { name: "France", avatar: srcs[5] },
    { name: "Japan", avatar: srcs[1] },
    { name: "South Korea", avatar: srcs[3] },
  ];
  return countries.filter((country) => country.name.includes(name));
}

export function generateRandomStr(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result + "@#!";
}

export function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export function createMonthObject(monthNumber) {
  const monthName = convertMonthNumberToName(monthNumber);
  if (monthName) {
    return {
      id: monthNumber,
      name: monthName,
    };
  }
  return null; // Or handle the error appropriately
}

export function convertMonthNumberToName(monthNumber) {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  if (monthNumber < 1 || monthNumber > 12) {
    return null; // Or throw an error if you prefer
  }

  return monthNames[monthNumber - 1];
}

export function validateEmail(email) {
  // Added apostrophe to the allowed characters in the local part
  if (/^[\w.+'-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/.test(email) == false) {
    this.$toast.error("Please enter a valid email.");
    return;
  }
}

/**
 *
 * @param {Object} obj The object to be converted
 * @param {String} prefix The prefix for encoded key
 * @returns {String} The url params
 */
export function objectToUrlParams(obj, prefix = "") {
  let params = [];
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key];
      const encodedKey = prefix ? `${prefix}[${key}]` : key;

      if (typeof value === "object" && value !== null) {
        params.push(objectToUrlParams(value, encodedKey));
      } else {
        params.push(
          `${encodeURIComponent(encodedKey)}=${encodeURIComponent(value)}`
        );
      }
    }
  }
  return params.join("&");
}

/**
 * Capitalize first letter of a string.
 * @param {string} string The string provided
 * @returns {string} The string with capitalized first letter
 */
export function capitalizeFirstLetter(string) {
  if (!string) return null;

  return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 *
 * @param {String} date The date string
 * @param {String} format The format to be followed
 * @returns {String} The formatted date string
 */
export function formatDate(date, format = "DD-MMM-YYYY") {
  if (!date) return null;

  return moment.utc(new Date(date)).format(format);
}

/**
 * Remove an item from an array by key
 * @param {Array} items The array of items
 * @param {Number} index The index to be removed
 * @returns {Array} The new array with removed item
 */
export function removeItem(items, index) {
  if (!Array.isArray(items)) return;
  if (index == null) return;

  items.splice(index, 1);

  return items;
}

/**
 * Check if the value exists in the array
 * @param {*} value The value to find
 * @param {String} key The key in the array
 * @param {Array} items The array
 * @returns {Boolean} Return bolean if value exists
 */
export function itemExistsInArray(value, key, items) {
  if (key == null) return;
  if (!Array.isArray(items)) return;

  let exists = false;

  for (let index = 0; index < items.length; index++) {
    const element = items[index];

    if (element[key] == value) {
      exists = true;
      break;
    }
  }

  return exists;
}

/**
 * Remove an item by specifying the value
 * @param {*} value THe value to find
 * @param {String} key The key in the array
 * @param {Array} items The array
 * @returns {Array} The new array of items
 */
export function removeItemByValue(value, key, items) {
  if (!Array.isArray(items)) return null;
  if (!value) return null;

  let newItems = [];

  items.forEach((el) => {
    if (el[key] != value) {
      newItems.push(el);
    }
  });

  return newItems;
}

/**
 *
 * @param {String} id The id of the modal component
 * @param {String} status The status of the modal (show/hide - show by default)
 */
export function toggleModal(id, status = "show") {
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent("toggle-app-modal", {
        detail: { id, status },
      })
    );
  }

  const modalEl = document.getElementById(id);
  if (!modalEl) return;

  if (modalEl.classList && modalEl.classList.contains("modal")) {
    try {
      let modalInstance = Modal.getInstance(modalEl, {
        keyboard: false,
      });

      if (!modalInstance) {
        modalInstance = new Modal(modalEl);
      }

      if (status == "show") modalInstance.show();
      else modalInstance.hide();
    } catch (e) {
      // Element is not a bootstrap modal
    }
  }
}

/**
 * Decapitalize first letter of a string.
 * @param {string} string The string provided
 * @returns {string} The string with decapitalized first letter
 */
export function deCapitalizeFirstLetter(string) {
  if (!string) return null;

  return string.charAt(0).toLowerCase() + string.slice(1);
}

/**
 * Download process
 * @param {Blob} response The blob response
 * @param {String} filename The filename
 */
export function startDownload(response, filename) {
  // Create a new Blob from the response data
  // response.data is already a Blob when responseType is 'blob'
  const blob = new Blob([response.data], { type: "text/csv" });

  // Create a URL for the Blob object
  const url = window.URL.createObjectURL(blob);

  // Create a temporary link element
  const link = document.createElement("a");
  link.href = url;
  // Set the download attribute to specify the filename
  link.setAttribute("download", filename);
  document.body.appendChild(link); // Append the link to the body (necessary for Firefox)
  link.click(); // Programmatically click the link to trigger the download

  // Clean up: revoke the object URL to free up memory
  window.URL.revokeObjectURL(url);
  link.remove(); // Remove the link element from the DOM
}

export function evaluatePermissions(jwtPayload) {
  let isSuperAdmin = false;
  let isOrganisationAdmin = false;
  let hasProduct = false;

  if (jwtPayload && jwtPayload.roles && Array.isArray(jwtPayload.roles)) {
    isSuperAdmin = jwtPayload.roles.includes("super_admin");
  }

  if (
    jwtPayload &&
    jwtPayload.organisation_role &&
    Array.isArray(jwtPayload.organisation_role) &&
    jwtPayload.organisation_role.length > 0
  ) {
    const orgRole = jwtPayload.organisation_role[0];
    hasProduct = Boolean(orgRole && orgRole.products);
    isOrganisationAdmin = Boolean(orgRole && orgRole.is_organisation_admin);
  }

  return { isSuperAdmin, isOrganisationAdmin, hasProduct };
}

/**
 *
 * @param {Number} num The number to be formated
 * @returns Returns formatted number with rounding
 */
export function formatNumber(num, decimals = 2) {
  return num.toFixed(decimals);
}

/**
 * Used for exporting reports, Capitalize headers
 * @param {Array} headers Headers
 * @returns Capitalized headers
 */
export function getHeaders(headers) {
  const capitalizedHeaders = [];

  headers.forEach((el) => {
    if (el.name != "Actions") capitalizedHeaders.push(el.name.toUpperCase());
  });

  return capitalizedHeaders;
}

/**
 * Set modal persistence
 * @param {String} id - The Id of the modal
 * @param {String} mode - static will prevent modal from closing when clicking outside
 */
export function setModalBackdrop(id, mode = "static") {
  const modalEl = document.getElementById(id);
  if (!modalEl) return;

  try {
    let modalInstance = Modal.getInstance(modalEl);

    if (!modalInstance) {
      modalInstance = new Modal(modalEl);
    }

    if (modalInstance && modalInstance._config) {
      modalInstance._config.backdrop = mode;
    }
  } catch (e) {
    // ignore
  }
}

// helper function for getting cookie
export function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export function parseAddressComponents(addressComponents) {
  const componentMap = {};
  for (const component of addressComponents) {
    for (const type of component.types) {
      componentMap[type] = component;
    }
  }

  const get = (type, useShortName = false) => {
    const component = componentMap[type];
    if (!component) return "";
    return useShortName ? component.short_name : component.long_name;
  };

  const streetNumber = get("street_number");
  const route = get("route");
  let address = `${streetNumber} ${route}`.trim();
  if (!address) {
    address = get("premise");
  }

  const postalCode = get("postal_code");
  const postalCodeSuffix = get("postal_code_suffix");
  let fullPostalCode = postalCode;
  if (postalCode && postalCodeSuffix) {
    fullPostalCode = `${postalCode}-${postalCodeSuffix}`;
  }

  const addressData = {
    address: address,
    address2: get("subpremise"),
    city: get("locality") || get("postal_town") || get("sublocality"),
    state: get("administrative_area_level_1", true),
    country: get("country"),
    postalCode: fullPostalCode,
  };

  return addressData;
}

export function isEmptyObject(obj) {
  // Check if the input is actually an object and not null
  if (typeof obj !== "object" || obj === null) {
    return false; // Or throw an error, depending on desired behavior
  }
  return Object.keys(obj).length === 0;
}

export const sanitizeCsvField = (value) => {
  if (value === null || value === undefined) {
    return "";
  }
  let str = String(value);
  if (str.length > 0) {
    const firstChar = str[0];
    const trimmedFirstChar = str.trimStart()[0];
    const formulaChars = ["=", "+", "-", "@", "\t", "\r"];
    if (formulaChars.includes(firstChar) || formulaChars.includes(trimmedFirstChar)) {
      str = "'" + str;
    }
  }
  if (
    str.includes(",") ||
    str.includes('"') ||
    str.includes("\n") ||
    str.includes("\r")
  ) {
    str = '"' + str.replace(/"/g, '""') + '"';
  }
  return str;
};

export function install(app) {
  app.config.globalProperties.$sanitizeCsvField = sanitizeCsvField;
}

export default {
  install,
};
